// extracted by mini-css-extract-plugin
export default {"page":"SettingsPage_page__oAZG2","page__cont":"SettingsPage_page__cont__UX+re","pageWrap":"SettingsPage_pageWrap__JV6kK"};